import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import Icon from './Icon'
import { DIVISION_IMAGES } from '../images/divisions'
import { ROUTE } from '../config'

import '../styles/DivisionCard.scss'

export default function DivisionCard({ division }) {
  const image = DIVISION_IMAGES[division.imageKey]

  return (
    <Link
      className="DivisionCard"
      to={`${ROUTE.DIVISIONS}/${division.key}${ROUTE.VEHICLES}`}
    >
      <div className="DivisionCard-image">
        {image ? <img src={image} alt="" /> : null}
      </div>
      <div className="DivisionCard-label">
        <span className="DivisionCard-title">{division.title}</span>
        <Icon type="arrow-right" className="DivisionCard-chevron" />
      </div>
    </Link>
  )
}

DivisionCard.propTypes = {
  division: PropTypes.shape({
    key: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    imageKey: PropTypes.string.isRequired,
  }).isRequired,
}
